"use strict";
/* eslint-disable quote-props */
/* eslint-disable quotes */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. checkRole(userRoles, roleTypes.SUPER_ADMIN) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 */
const roles = {
    SYSTEM_ADMIN: 'SYSTEM_ADMIN',
    SUPER_ADMIN: 'SUPER_ADMIN',
    CASE_MANAGER: 'CASE_MANAGER',
    OPERATIONAL_SUPPORT: 'OPERATIONAL_SUPPORT',
    STRATEGIST: 'STRATEGIST',
    STUDENT: 'STUDENT',
    EXTERNAL_STUDENT: 'EXTERNAL_STUDENT',
    TUTOR: 'TUTOR',
    HEAD_TUTOR: 'HEAD_TUTOR',
    DEVELOPER: 'DEVELOPER',
    ACCOUNTS: 'ACCOUNTS',
    BOT: 'BOT',
    BOOKING_ADMINISTRATOR: 'BOOKING_ADMINISTRATOR',
    ALPHA_TESTER: 'ALPHA_TESTER',
    BETA_TESTER: 'BETA_TESTER',
    SYSTEM_OPERATOR: 'SYSTEM_OPERATOR',
    SUBSCRIPTION_USER: 'SUBSCRIPTION_USER',
    REVIEWER: 'REVIEWER',
    COMMUNITY_ADMIN: 'COMMUNITY_ADMIN',
    COMMUNITY_MODERATOR: 'COMMUNITY_MODERATOR',
    COMMUNITY_USER: 'COMMUNITY_USER',
    COMMUNITY_BLOCKED_USER: 'COMMUNITY_BLOCKED_USER',
    CGA_STUDENT: 'CGA_STUDENT',
    CGA_STAFF: 'CGA_STAFF',
    RISE_STUDENT: 'RISE_STUDENT',
    US_OPS_ADMIN: 'US_OPS_ADMIN',
    EDITOR_US_ESSAYS: 'EDITOR_US_ESSAYS',
    ECL_OPS_ADMIN: 'ECL_OPS_ADMIN',
    EDITOR_ECL: 'EDITOR_ECL',
    GUARDIAN: 'GUARDIAN',
    ACADEMIC_ADVISOR: 'ACADEMIC_ADVISOR',
    CRIMSON_STAFF: 'CRIMSON_STAFF',
    RECORDING_MANAGER: 'RECORDING_MANAGER',
};
exports.default = roles;
//# sourceMappingURL=roles.js.map